// extracted by mini-css-extract-plugin
export default {"empty-content":"styles_empty-content__b9q5D","text-wrapper":"styles_text-wrapper__LKay1","title":"styles_title__7aBPD","subtitle":"styles_subtitle__NChF0"};